import { render, staticRenderFns } from "./ProveedoresList.vue?vue&type=template&id=e11e4cba&"
import script from "./ProveedoresList.vue?vue&type=script&lang=js&"
export * from "./ProveedoresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports